import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Tooltip from '@mui/material/Tooltip';
import NRInformationModal from '../../NRInformationModal/NRInformationModal';
import React, { useCallback, useRef, useState } from 'react';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import NRSecondaryLink from '../../NRSecondaryLink/NRSecondaryLink';
import CorrelationsGrid from './CorrelationsGrid/CorrelationsGrid';
import NRCorrelationsGridContainer from './NRCorrelationsGrid/NRCorrelationsGridContainer';
import { numberFilterOperations } from '../../NRReactGrid/NRReactGrid.utils';

const EnhancedCorrelationsFormatter = ({ value, column, row, assetCorrelationType, composedAssetId, getListAssetCorrelationsIdentifier }) => {
  const theme = useTheme();
  const { componentId: routeComposedAssetId } = useParams();
  const resolvedComposedAssetId = composedAssetId ?? routeComposedAssetId;
  const valueToUse = Array.isArray(value) ? value.length : value;
  const [open, setOpen] = useState(false);

  const correlationListIdentifier = typeof getListAssetCorrelationsIdentifier === 'function' ? getListAssetCorrelationsIdentifier(row) : undefined;
  const useListAssetCorrelationsQuery = !!assetCorrelationType && !!correlationListIdentifier;

  return (
    <>
      <Tooltip title={valueToUse > 0 ? column.tooltipA + valueToUse + column.tooltipB : ''}>
        <NRSecondaryLink
          value={valueToUse}
          handleOnClick={() => setOpen(true)}
          openNull={false}
          aria-label={`Correlations: ${valueToUse}. Opens correlation report.`}
        />
      </Tooltip>
      <NRInformationModal
        width={'60vw'}
        isOpen={open}
        setIsOpen={setOpen}
        maxWidth={'65vw'}
        maxHeight={'80vh'}
        paperOverflow="auto"
        paddingContainer={0}
        showCancelButton={true}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pb: theme.spacing(1.5)
          }}
        >
          <Typography variant="h3" component="span">
            {`${row?.title || 'Correlations'} - ${valueToUse}`}
          </Typography>
          <IconButton aria-label="Close" onClick={() => setOpen(false)} size="large">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {open &&
          (useListAssetCorrelationsQuery ? (
            <NRCorrelationsGridContainer
              setOpen={setOpen}
              composedAssetId={resolvedComposedAssetId}
              correlationType={assetCorrelationType}
              identifier={correlationListIdentifier}
            />
          ) : (
            <CorrelationsGrid setOpen={setOpen} rows={row?.correlations} />
          ))}
      </NRInformationModal>
    </>
  );
};

export const EnhancedCorrelationsProvider = ({ extraParams, ...props }) => {
  const extraParamsRef = useRef(extraParams ?? {});
  extraParamsRef.current = extraParams ?? {};

  const Formatter = useCallback(
    formatterProps => <EnhancedCorrelationsFormatter {...formatterProps} {...extraParamsRef.current} />,
    []
  );

  return <DataTypeProvider formatterComponent={Formatter} availableFilterOperations={numberFilterOperations} {...props} />;
};
